/**
 * Essa função faz merge de dois arrays usando o id dos itens
 */
export const mergeById = (
  array1: Record<string, any>[],
  array2: Record<string, any>[],
) =>
  array1.map((item1) => ({
    ...array2.find((item2) => item2.id === item1.id && item2),
    ...item1,
  }));
